import React, { Component } from 'react'

export class Errror extends Component {
  render() {
    return (
      <div>Errror</div>
    )
  }
}

export default Errror